<template>
  <!-- 不能用 trigger="hover（否则输入泳道时会自动收起，导致无法输入泳道）" -->
  <mtd-dropdown v-if="!isProd" :visible="visible">
    <mtd-button class="env-button" type="text-primary" @click="toggleVisible">
      <span :class="[envClass, 'mc-env-label']">
        {{ envLabel }}
      </span>
      <span class="mc-env-en">{{ envEnDesc }}</span>
      <i v-if="!visible" class="mtdicon mtdicon-triangle-down icon-color" />
      <i v-else class="mtdicon mtdicon-triangle-up icon-color" />
    </mtd-button>
    <template #dropdown>
      <mtd-dropdown-menu>
        <mtd-dropdown-menu-item v-for="item in envSelectList" :key="item.value">
          <a :href="item.link" target="_blank">{{ item.label }}</a>
        </mtd-dropdown-menu-item>
        <mtd-dropdown-menu-item v-if="envUrlMap.test" class="swimlane-item">
          <mtd-input
            v-model="swimlane"
            type="text"
            placeholder="e.g. 1975-alfwe"
            @change="changeSwimlane"
          />
          <mtd-button
            class="swimlane-btn"
            type="primary"
            style="margin-left: 10px"
            :href="swimlaneLink"
            target="_blank"
            @click="toggleVisible"
          >
            跳转泳道
          </mtd-button>
        </mtd-dropdown-menu-item>
      </mtd-dropdown-menu>
    </template>
  </mtd-dropdown>
</template>

<script>
import {
  Dropdown as MtdDropdown,
  DropdownMenu as MtdDropdownMenu,
  Button as MtdButton,
  Input as MtdInput,
} from "@ss/mtd-vue";
import { getValuesFromList } from "../utils";
import { envList, urlList } from "../constants";
import { EnvNames } from "../interface";

const getEnvMaps = () => {
  const envLabelMap = getValuesFromList(envList, "value", "label");
  const envDescMap = getValuesFromList(envList, "value", "desc");
  const envClassMap = getValuesFromList(envList, "value", "class");
  return { envLabelMap, envDescMap, envClassMap };
};

const getEnvSelectList = (envUrlMap, activeEnv, envMaps) => {
  const envRange = Object.keys(envUrlMap).filter((v) => v !== activeEnv);
  return envRange.map((e) => {
    const link = `${envUrlMap[e]}${window.location.pathname}`;
    const label = `${envMaps.envLabelMap[e]}|${envMaps.envDescMap[e]}`;
    return {
      link,
      value: e,
      label,
    };
  });
};

const getSwimlaneLink = (testUrl, swimlane) => {
  const host = testUrl.replace("//", `//${swimlane}-sl-`);
  return `${host}${window.location.pathname}`;
};

export default {
  name: "EnvSelect",
  components: {
    MtdDropdown,
    MtdDropdownMenu,
    MtdButton,
    MtdInput,
  },
  props: {
    activeEnv: {
      required: true,
      type: String,
    },
  },
  inject: {
    systemType: {
      default: "",
    },
  },
  data() {
    const envMaps = getEnvMaps();
    return {
      visible: false,
      envMaps: envMaps,
      envUrlMap: urlList[this.systemType] || {},
      swimlane: "",
      swimlaneLink: "",
    };
  },
  computed: {
    isProd() {
      return this.activeEnv === EnvNames.Production;
    },
    envClass() {
      return this.envMaps.envClassMap[this.activeEnv];
    },
    envLabel() {
      return this.envMaps.envLabelMap[this.activeEnv];
    },
    envEnDesc() {
      return this.envMaps.envDescMap[this.activeEnv];
    },
    envSelectList() {
      return getEnvSelectList(this.envUrlMap, this.activeEnv, this.envMaps);
    },
  },
  methods: {
    changeSwimlane() {
      this.swimlaneLink = getSwimlaneLink(
        this.envUrlMap.test || "",
        this.swimlane
      );
    },
    toggleVisible() {
      this.visible = !this.visible;
    },
  },
};
</script>

<style scoped>
.icon-color {
  position: absolute;
  font-size: 32px;
  margin-left: -8px;
  bottom: 0.1px;
}

.env-button {
  margin-inline-end: 32px;
}
</style>
